import React, { useEffect, useState } from "react";
import { PricingInterface } from "./Onboarding/PricingInterface/PricingInterface";
import { StepIndicator } from "./Onboarding/StepIndicator";
import { GetStartedButton } from "./Onboarding/GetStartedButton";
import styles from "./Onboarding/OnboardingModal.module.scss";
import { useOutletContext } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ComparisonTable } from "./Onboarding/ComparisonTable";

const steps = [
  {
    heading: "A giant, searchable gallery <br/> of iPhone apps in action.",
    subtext:
      "Explore 1,800+ subscription iOS apps with video walkthroughs of every <br/> onboarding, paywall and upgrade loop. Filter by revenue, installs, category. <br/> Research and build winning flows in minutes.",
    buttonText: "Continue",
  },
  {
    content: <ComparisonTable />,
    buttonText: "Get Started",
  },
  // {
  //   content: <PricingInterface />,
  // },
];

export const OnboardingModal = () => {
  const { popupVisible, setPopupVisible } = useOutletContext();
  const [currentStep, setCurrentStep] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("hasSeenOnboardingModal");
    if (!hasSeenPopup) {
      setPopupVisible(true);
      localStorage.setItem("hasSeenOnboardingModal", "true");
    }
  }, [popupVisible]);

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      setPopupVisible(false);
    }
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setMousePosition({ x, y });
  };

  return (
    <AnimatePresence>
      {popupVisible && (
        <div className={styles.overlay} onClick={() => setPopupVisible(false)}>
          <motion.div
            onClick={(e) => {
              e.stopPropagation();
              if (currentStep < steps.length - 1) {
                handleNext();
              }
            }}
            onMouseMove={handleMouseMove}
            className={styles.modal}
            style={{
              cursor: currentStep < steps.length - 1 ? "pointer" : "default",
              background: `linear-gradient(135deg, #4338ca 0%, #8b5cf6 100%)`,
            }}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5, x: "-100%", y: "-100%" }}
            transition={{ duration: 0.5 }}
          >
            <div className={styles.contentWrapper}>
              <StepIndicator
                totalSteps={steps.length}
                currentStep={currentStep}
                onStepClick={setCurrentStep}
              />

              <div className={styles.textContainer}>
                {steps[currentStep].heading && (
                  <h2
                    className={styles.heading}
                    dangerouslySetInnerHTML={{
                      __html: steps[currentStep].heading,
                    }}
                  ></h2>
                )}
                {steps[currentStep].subtext && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: steps[currentStep].subtext,
                    }}
                    className={styles.subtext}
                  ></p>
                )}
                {steps[currentStep].content}

                {(currentStep === 0 || currentStep === 1) && (
                  <div>
                    <div className={styles.flexCenter}>
                      <button
                        className={styles.seePricing}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNext();
                        }}
                      >
                        {steps[currentStep].buttonText}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
